/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Save_Failed1Inputs */

const vi_sitesettings_save_failed1 = /** @type {(inputs: Sitesettings_Save_Failed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không lưu được cài đặt website. Kiểm tra mạng rồi bấm Lưu lại.`)
};

/**

* @param {Sitesettings_Save_Failed1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_save_failed1 = /** @type {((inputs?: Sitesettings_Save_Failed1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Save_Failed1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_save_failed1(inputs)
});
export { sitesettings_save_failed1 as "siteSettings_save_failed" }